<template>
  <b-container fluid>
    <b-row align-h="center" align="center">

      <b-col cols="12" md="10" lg="7">
        <b-row no-gutters > 
          <b-col >
            <b-img src="@/assets/portadapagos.jpg"  fluid-grow alt="Fluid-grow image"></b-img>
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col cols="12">
            <h4>Da click para continuar con el pago.</h4>
          </b-col>
          <b-col class="mt-4">
            <b-button size="lg"  pill variant="success" @click="iniciarPagoPW"> Pagar En Línea <b-icon icon="credit-card2-back-fill"/></b-button>
          </b-col>
          
        </b-row>
        <b-row v-if="false">
          <b-col class="mt-3">
            <b-form-textarea rows="10" v-model="params"></b-form-textarea>
          </b-col>
        </b-row>
        
      </b-col>
    </b-row>

   
  </b-container>
</template>


<script>
import { mapState} from 'vuex';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  computed:{
    ...mapState({
      parcialidades: state => state.contribuyente.parcialidades,
      totalLiquidacion: state => state.contribuyente.totalLiquidacion,
      datosPago: state => state.contribuyente.datosPago,
      isCalculando: state => state.contribuyente.isCalculando,
      isGenerando: state => state.contribuyente.isGenerando,
      idxUltParcialidad: state => state.contribuyente.idxUltParcialidad,
      msgErrorContribuyente: state => state.contribuyente.msgErrorContribuyente,
      msgErrorGenLinea: state => state.contribuyente.msgErrorGenLinea,
      terminosServicio: state => state.contribuyente.catalogContribuyente.terminosServicio,
      thems: state => state.contribuyente.catalogContribuyente.thems,
      test: state => state.contribuyente.test
    }),
    
  },
  mounted() {
    const recaptchaScript2 = document.createElement("script");
     recaptchaScript2.setAttribute(
       "src",
       "https://multicobros.banorte.com/orquestador/resources/js/jquery-3.3.1.js"
     );
      recaptchaScript2.type = 'text/javascript';
     document.head.appendChild(recaptchaScript2);
     


     const recaptchaScript = document.createElement("script");
     recaptchaScript.setAttribute(
       "src",
       "https://multicobros.banorte.com/orquestador/lightbox/checkoutV2.js"
     );
      recaptchaScript.type = 'text/javascript';
     document.head.appendChild(recaptchaScript);

     
  },
  data(){
    return{
      urlAction:"",
      formData:{
      },
      params:"r6Z0x7z/YcBRmAmM8lDE5M/RkvvddFcniXlA0kdd8GrCfmL3/mpveTLZa8BcqzVAxTVFsacYEEPUFQyH6QeFnnHYmMvsWTd0tzi+zCt0P+rA6q8RejnGmcS5Nwf4jlDoCeWevlFfOjaMFVQzAM1IOlBVimk222zeN1askNlaYfzZK1HfWTweUWRYouMWMFrhOZj9XaOEemNWJwLQ7ySv6i2VKIWvZEaIIgKhuAqW8VKMck9VYMTTbOjLtq2xXnuqzV0PFhLKforT0homGMqo0j6Vb5YSwo5PSpvYmlDgjZrZ6doJ14suefW6uhfSJVJhAs/EFXU8bXeRTJWt7WlnQw==:::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",
      codeClient:this.$route.params.municipio,
    }
  },
  components: {
  },
  created: function () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.params=urlParams.get('chain').replaceAll(' ','+');
  },
  methods:{
    iniciarPagoPW(){

    const propScript = document.createElement("script");

     propScript.type = 'text/javascript';


      var sendConde = ''+
       'function sendResp(resp){ '+
       //'    fetch("http://localhost:8080/'+this.codeClient+'/payworkend?respenc="+resp.data.replaceAll("+","%2B"), {       '+
       '    fetch("https://recaudacion.gobinet.mx/'+this.codeClient+'/payworkend?respenc="+resp.data.replaceAll("+","%2B"), {       '+
       '      method: "POST",                            '+
       '    })                                           '+
       '      .then((response) => response.json())       '+
       '      .then((data) => {                          '+
       '        console.log("Success:", data);           '+
       '        window.location.replace("https://www.tula.gob.mx");  '+
       '      })                                         '+
       '      .catch((error) => {                        '+
       '        console.error("Error:", error);          '+
       '        window.location.replace("https://www.tula.gob.mx");  '+
       '      });                                        '+
       '} ';

      
      var code = ''+
      sendConde+
      '     alert("Serás dirijido al servicio de cobro Banorte");'+
      '     Payment.setEnv("pro");		'+
      '		  var xObjEnc = "'+this.params+'";'+
      '		  Payment.startPayment(		{'+
      ' 		  Params: xObjEnc , '+
      '		    onClosed: function(response) { 			console.log(response);	sendResp(response)	  },'+
      ' 		  onError: function(response) {				console.log(response);	sendResp(response)	  },'+
      '       onSuccess: function(response) { 		console.log(response);	sendResp(response)	  }, '+
      '       onCancel: function(response) { 			console.log(response);	sendResp(response)	  } 	  });  ';

      //alert(code);
      try {
       propScript.appendChild(document.createTextNode(code));
       document.head.appendChild(propScript);
     } catch (e) {
       propScript.text = code;
       document.head.appendChild(propScript);
     }


     /*
      const getCircularReplacer = () => {
          const seen = new WeakSet();
          return (key, value) => {
              if (typeof value === "object" && value !== null) {
                  if (seen.has(value)) {
                      return;
                  }
                  seen.add(value);
              }
              return value;
          };
      };

      this.keyValues = JSON.stringify(window, getCircularReplacer());*/


      /*
      window.Payment.setEnv("pro");
      var xObjEnc = this.params;
      window.Payment.startPayment({ 
        Params: xObjEnc , 
        onClosed: function(response) { 
        // TO DO Code Here when close the modal
        alert(response); 
        }, 
        onError: function(response) { 
          alert(response); 
          // TO DO Code Here when an error occurred 
        }, 
        onSuccess: function(response) { 
          alert(response); 
          // TO DO Code Here when operation is successful 
        }, onCancel: function(response) { 
          alert(response); 
          // TO DO Code Here when user cancel operation 
        } }); */
    },

  },
  validations:{
    
  }
}
</script>
<style>
  .input-multi{
    color: white;
    border: white;
    font-size : 1px;
  }
  .form-submit-button {
    font-size : 38px;
    padding: 5px;
    background: #28A745;
    color: #fff;
    border: 1px solid #eee;
    border-radius: 33px;
    box-shadow: 5px 5px 5px #eee;
    text-shadow: none;
  }
    .form-submit-button:hover {
    background: #75C592;
    color: #fff;
    border: 1px solid #eee;
    border-radius: 33px;
    box-shadow: 5px 5px 5px #eee;
    text-shadow: none;
  }
</style>